module.exports = __webpack_public_path__ + "static/img/page03.1bc2fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page03.jpg
// module id = OqGi
// module chunks = 0